import { useEffect } from 'react';
import { generatePath } from 'react-router-dom';
import useRouter from 'app/hooks/useRouter';
import useConfig from 'app/hooks/useConfig';
import useSession from 'app/hooks/useSession';

export default function (step, movieCinemaId) {
  const { history } = useRouter();
  const { routes } = useConfig();
  const session = useSession();

  useEffect(() => {
    const listener = (location, action) => {
      if (
        action === 'POP' &&
        (generatePath(routes.stepSeats.pattern, { movieCinemaId }) ||
          generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }) ||
          generatePath(routes.stepCheckout.pattern, { movieCinemaId })
        )
      ) {
        const route = session.getRoute();

        if (route) {
          session.removeRoute();
          history.push(route);
        } else {
          setTimeout(() => history.push(routes.fallback.pattern), 0);
        }
      }
    };

    return history.listen(listener);
  }, [history, session, routes, step, movieCinemaId]);
}
